(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sizes-toggle]');
    if (toggle) {
      var wrapper = toggle.closest('[data-sizes-wrapper]');
      var panel = wrapper && wrapper.querySelector('[data-sizes-panel]');
      if (!panel) return;

      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    var sizeItem = event.target.closest('.product-card__sizes-item:not(.is-unavailable)');
    if (!sizeItem) return;

    var variantId = sizeItem.getAttribute('data-variant-id');
    if (!variantId || variantId === '') return;

    var card = sizeItem.closest('product-card');
    if (!card) return;

    var link = card.querySelector('.product-card__link');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    var separator = href.indexOf('?') === -1 ? '?' : '&';
    window.location.href = href + separator + 'variant=' + variantId;
  });
})();